import React from 'react';
import { HeadContent, Subsection } from '@fourthwall/components';
import { ConnectedSitesList } from './components/ConnectedSitesList/ConnectedSitesList';
export const CONNECTED_SITES_TITLE = 'Connected sites';
export const ConnectedSitesView = ({ items = [] }) => (React.createElement(React.Fragment, null,
    React.createElement(HeadContent, { title: `${CONNECTED_SITES_TITLE} \u2013 Account settings` }),
    React.createElement(Subsection, { title: CONNECTED_SITES_TITLE }, !!items.length && (React.createElement("div", { style: { marginTop: -12 - 4 } },
        React.createElement(ConnectedSitesList, { items: items }))))));
